import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IAuxiliaryWindowService = ( createDecorator('auxiliaryWindowService'));
export { IAuxiliaryWindowService };
